<template>
  <AppDialog
    :is-open="isDialogOpened"
    :cancel-text="$t('common.cancel')"
    :ok-text="$t('common.confirm')"
    :ok-loading="isPending"
    :cancel-disabled="isPending"
    size="m"
    @cancel="closeDialog"
    @ok="confirmClick"
  >
    <template #title>
      <span>
        {{ $t('project.signing-checklist.prepare-signature.PrepareSignatureDeleteAllTagsDialog.dialogTitle') }}
      </span>
    </template>

    <template #body>
      <p>{{ $t("project.signing-checklist.prepare-signature.PrepareSignatureDeleteAllTagsDialog.dialogBody") }}</p>
    </template>
  </AppDialog>
</template>

<script>
import { defineComponent } from 'vue'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'PrepareSignatureDeleteAllTagsDialog',
  components: { AppDialog },
  props: {
    isPending: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [dialogMixin],
  methods: {
    confirmClick () {
      this.$emit('delete-all-tags')
      this.closeDialog()
    },
  },
})
</script>
